<div class="app-container">
  <!--  <page-header [title]="isCreationModeEnabled ? 'purchase.new' : ('purchase.detail' | translate) + ' ' + purchaseOrder?.externalReference">-->
  <page-header [title]="''">
    <!--  <page-header [title]="isCreationModeEnabled ? 'purchase.new' : purchaseOrder?.externalReference">-->
    <ng-container class="custom-title">
      <div class="d-flex align-items-center">
        <div class="mr-3">
          {{ (isCreationModeEnabled ? 'purchase.new' : purchaseOrder?.externalReference) | translate }}
        </div>
        <div *ngIf="purchaseOrder?.status?.id === 'draft'" class="text-primary mr-3">
          ({{ 'purchaseOrder.status.draft.short' | translate }})
        </div>
        <div>
          <img src="assets/img/purchase-orders-hs-logo.png" alt="" class="company-img" />
        </div>
      </div>
      <!--      <div class="status-div margin-left" [ngClass]="'status-' + purchaseOrder?.status?.id" [title]="purchaseOrder?.status?.name | translate">-->
      <!--        {{ purchaseOrder?.status?.name | translate }}-->
      <!--      </div>-->
    </ng-container>
    <ng-container class="header-button">
      <btn
        *ngIf="isEditModeEnabled || purchaseOrder?.status?.id === 'draft'"
        [label]="'purchaseOrder.continue.to.checkout'"
        [title]="'purchaseOrder.continue.to.checkout' | translate"
        [classes]="['btn-first']"
        [icon]="''"
        [spinnerClassesString]="'spinner-white'"
        [btnType]="'submit'"
        (click)="continueToCheckout()"
        [btnDisabled]="!(purchaseOrderInfo.supplier && purchaseOrderInfo.depot)"
        [dataCyAttribute]="'create-purchase-order-button'"
      ></btn>
      <btn
        *ngIf="isEditModeEnabled && (!purchaseOrder?.status?.id || purchaseOrder?.status?.id === 'draft')"
        [label]="'purchaseOrder.save.as.draft'"
        [title]="'purchaseOrder.save.as.draft' | translate"
        [classes]="['btn-third', 'mr-2']"
        [icon]="'far-lightbulb'"
        [spinnerClassesString]="'spinner-white'"
        [btnType]="'submit'"
        (click)="saveAsDraft()"
        [btnDisabled]="!(purchaseOrderInfo.supplier && purchaseOrderInfo.depot)"
        [dataCyAttribute]="'create-purchase-order-button-draft'"
      ></btn>

      <!--      <div *ngIf="isEditModeEnabled" class="info-text-price d-flex align-items-center mt-0">-->
      <!--        <p class="m-0">-->
      <!--          {{ 'price.info-text-1' | translate }}-->
      <!--          <br />-->
      <!--          {{ 'price.info-text-2' | translate }}-->
      <!--        </p>-->
      <!--        <i class="fal fa-info-circle"></i>-->
      <!--      </div>-->
      <dropdown
        *ngIf="
          purchaseOrder?.id > 0 &&
          purchaseOrder?.status?.id !== 'stocked' &&
          purchaseOrder?.status?.id !== 'draft' &&
          !isEditModeEnabled
        "
        [icon]="'fas-chevron-down'"
        [label]="'purchase-order.stock.dropdown-label'"
        [items]="[
          { action: 'stockUp', label: 'purchase-order.stock.all', isSelected: false },
          { action: 'stockUpInMobileApp', label: 'purchase-order.stock.all.mobile', isSelected: false },
        ]"
        [isArrowHidden]="true"
        [autoClose]="true"
        [classes]="['mr-2', 'float-right', 'custom-dropdown']"
        [theme]="'first'"
        (onResult)="stockUpAction($event)"
      ></dropdown>
      <btn
        *ngIf="
          canEdit &&
          !isCreationModeEnabled &&
          !isEditModeEnabled &&
          (purchaseOrder?.status?.id === 'new' || purchaseOrder?.status?.id === 'draft') &&
          (!purchaseOrder.customData?.supplierStatus || purchaseOrder.customData?.supplierStatus === 'none')
        "
        [label]="'purchase-order.delete'"
        [title]="'purchase-order.delete' | translate"
        [classes]="['btn-third', 'mr-2', 'float-right']"
        [isLoading]="loading"
        [icon]="'far-trash-alt'"
        (onEvent)="delete()"
        data-cy="delete-purchase-order"
      ></btn>
      <btn
        *ngIf="
          canEdit &&
          !isEditModeEnabled &&
          purchaseOrder?.status?.id !== 'new' &&
          purchaseOrder?.status?.id !== 'stocked' &&
          purchaseOrder?.status?.id !== 'cancelled'
        "
        [label]="'purchase-order.edit'"
        [title]="'purchase-order.edit' | translate"
        [classes]="['btn-third', 'mr-2', 'float-right']"
        [isLoading]="loading"
        [icon]="'far-pencil'"
        (onEvent)="isEditModeEnabled = !isEditModeEnabled"
        data-cy="edit-purchase-order"
      ></btn>
      <btn
        *ngIf="
          canEdit &&
          isEditModeEnabled &&
          purchaseOrder?.status?.id !== 'new' &&
          purchaseOrder?.status?.id !== 'stocked' &&
          purchaseOrder?.status?.id !== 'cancelled' &&
          purchaseOrder?.status?.id !== 'draft'
        "
        [label]="'purchase-order.edit.cancel'"
        [title]="'purchase-order.edit.cancel' | translate"
        [classes]="['btn-third', 'mr-2', 'float-right']"
        [isLoading]="loading"
        [icon]="'far-pencil'"
        (onEvent)="isEditModeEnabled = !isEditModeEnabled"
        data-cy="cancel-edit-purchase-order"
      ></btn>
      <dropdown
        *ngIf="purchaseOrder?.id > 0 && !isEditModeEnabled"
        [icon]="'fas-chevron-down'"
        [label]="'purchase-order.export.dropdown-label'"
        [items]="[
          { action: 'excelUrl', label: 'purchase-order.export.excelUrl', isSelected: false },
          { action: 'excelWOPricesUrl', label: 'purchase-order.export.excelWOPricesUrl', isSelected: false },
          { action: 'pdfUrl', label: 'purchase-order.export.pdfUrl', isSelected: false },
          { action: 'pdfWOPricesUrl', label: 'purchase-order.export.pdfWOPricesUrl', isSelected: false },
        ]"
        [isArrowHidden]="false"
        [autoClose]="true"
        [classes]="['mr-2', 'float-right custom-dropdown']"
        [theme]="'third'"
        (onResult)="export($event)"
      ></dropdown>
    </ng-container>
    <ng-container class="back-button">
      <btn
        [label]="'back'"
        [title]="'back' | translate"
        [isBackButton]="true"
        [classes]="['btn-third', 'float-right', 'mr-2']"
        [icon]="'far-arrow-left'"
        (onEvent)="navigateBack()"
      ></btn>
    </ng-container>
  </page-header>
  <section class="content">
    <nav class="tab-container" type="pills" *ngIf="purchaseOrderId > 0">
      <ul role="tablist" class="nav nav-pills">
        <li class="nav-item product-tab-heading">
          <div
            (click)="activeTab = 'common'"
            (keyup)="activeTab = 'common'"
            tabindex="0"
            [ngClass]="activeTab === 'common' ? 'active' : ''"
            class="nav-link"
          >
            {{ 'purchase-orders.tab.common' | translate }}
          </div>
        </li>
        <li class="nav-item product-tab-heading" *ngIf="purchaseOrder?.externalId?.length > 0">
          <div
            (click)="activeTab = 'dls'"
            (keyup)="activeTab = 'dls'"
            tabindex="0"
            [ngClass]="activeTab === 'dls' ? 'active' : ''"
            class="nav-link"
          >
            {{ 'purchase-orders.tab.dls' | translate }}
          </div>
        </li>
        <li class="nav-item product-tab-heading">
          <div
            (click)="activeTab = 'pmps'"
            (keyup)="activeTab = 'pmps'"
            tabindex="0"
            [ngClass]="activeTab === 'pmps' ? 'active' : ''"
            class="nav-link"
          >
            {{ 'purchase-orders.tab.pmps' | translate }}
          </div>
        </li>
      </ul>
    </nav>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-0">
        <div *ngIf="activeTab === 'common'">
          <div class="row" *ngIf="!isEditModeEnabled">
            <div class="col-12 col-md-6 d-flex">
              <div class="card info-card w-100">
                <div>
                  <h3 class="card-title mb-2">
                    {{ 'info' | translate }}
                  </h3>
                </div>
                <div class="row" *ngIf="purchaseOrder?.status?.id === 'draft'">
                  <div class="col-12">
                    <div class="order-draft-box">
                      <span
                        class="far fa-exclamation-triangle text-red"
                        style="font-size: 18px; padding-right: 0.5rem"
                      ></span>
                      {{ 'purchaseOrder.status.draft.long' | translate }}
                    </div>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table m-0" *ngIf="purchaseOrder?.id > 0">
                    <tbody>
                      <tr>
                        <td class="pl-0 card-subheading no-hover">
                          {{ 'purchaseOrder.externalReference' | translate }}
                        </td>
                        <td class="text-right no-hover">
                          {{ purchaseOrder.externalReference }}
                        </td>
                      </tr>
                      <tr>
                        <td class="pl-0 card-subheading no-hover">
                          {{ 'dateCreatedLong' | translate }}
                        </td>
                        <td class="text-right no-hover">
                          {{ purchaseOrder.created | fmtDate: 'dd.MM.yyyy' }}
                        </td>
                      </tr>
                      <tr>
                        <td class="pl-0 card-subheading no-hover">
                          {{ 'createdBy' | translate }}
                        </td>
                        <td class="text-right no-hover">
                          {{ purchaseOrder.createdBy?.name || 'AUTO' }}
                        </td>
                      </tr>
                      <tr>
                        <td class="pl-0 card-subheading no-hover">
                          {{ 'purchaseOrder.shippingAddress' | translate }}
                        </td>
                        <td class="text-right no-hover">
                          {{ purchaseOrder.customData?.address?.name }}
                        </td>
                      </tr>
                      <tr>
                        <td class="pl-0 card-subheading no-hover">
                          {{ 'purchaseOrder.paymentType' | translate }}
                        </td>
                        <td class="text-right no-hover">
                          {{ purchaseOrder.customData?.payment | translate }}
                        </td>
                      </tr>
                      <tr>
                        <td class="pl-0 card-subheading no-hover">
                          {{ 'status' | translate }}
                        </td>
                        <td class="text-right no-hover">
                          {{ 'purchaseOrderStatus.' + purchaseOrder?.status?.id | translate }}
                        </td>
                      </tr>
                      <tr>
                        <td class="pl-0 card-subheading no-hover">{{ 'purchase.depot-to' | translate }}</td>
                        <td class="text-right no-hover">
                          {{ purchaseOrder.depot?.name }}
                        </td>
                      </tr>
                      <tr>
                        <td class="pl-0 card-subheading no-hover">{{ 'supplier' | translate }}</td>
                        <td class="text-right no-hover">
                          {{ purchaseOrder.supplier?.name }}
                        </td>
                      </tr>
                      <tr *ngIf="purchaseOrder.customData?.supplierStatus?.length > 0">
                        <td class="pl-0 card-subheading no-hover">
                          {{ 'purchaseOrder.supplierStatusHs' | translate }}
                        </td>
                        <td class="text-right no-hover">
                          {{ 'purchaseOrder.supplierStatusHs.' + purchaseOrder.customData?.supplierStatus | translate }}
                        </td>
                      </tr>
                      <tr *ngIf="!purchaseOrder.customData?.supplierStatus">
                        <td class="pl-0 card-subheading no-hover">
                          {{ 'purchaseOrder.supplierStatusHs' | translate }}
                        </td>
                        <td class="text-right no-hover">
                          {{ 'purchaseOrder.supplierStatusHs.none' | translate }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="card info-card w-100" *ngIf="purchaseOrderInfo.note">
                <div>
                  <h3 class="card-title mb-2">
                    {{ 'note' | translate }}
                  </h3>
                </div>
                {{ purchaseOrderInfo.note }}
              </div>
            </div>
          </div>

          <div *ngIf="isEditModeEnabled" class="card">
            <div class="row" *ngIf="purchaseOrder?.status?.id === 'draft'">
              <div class="col-12">
                <div class="order-draft-box">
                  <span
                    class="far fa-exclamation-triangle text-red"
                    style="font-size: 18px; padding-right: 0.5rem"
                  ></span>
                  {{ 'purchaseOrder.status.draft.long' | translate }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pr-0 pt-1">
                <form-row-input
                  [label]="'purchaseOrder.externalReference'"
                  [inputDisabled]="!isEditModeEnabled"
                  [(model)]="purchaseOrderInfo.externalReference"
                ></form-row-input>
              </div>
              <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pr-0 pt-1">
                <form-row-select
                  [label]="'purchase.depot-to'"
                  [options]="depots"
                  [(ngModel)]="purchaseOrderInfo.depot"
                  [required]="true"
                  [isSelectDisabled]="
                    !isEditModeEnabled || (purchaseOrder?.id > 0 && purchaseOrder?.status?.id !== 'new')
                  "
                  #depot="ngModel"
                ></form-row-select>
              </div>
              <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pr-0 pt-1">
                <form-row-select
                  [label]="'supplier'"
                  [options]="suppliers"
                  [(ngModel)]="purchaseOrderInfo.supplier"
                  [dataCyAttribute]="'supplier-select'"
                  [required]="true"
                  [isSelectDisabled]="
                    true // !isEditModeEnabled || (purchaseOrder?.id > 0 && purchaseOrder?.status?.id !== 'new')
                  "
                  #supplier="ngModel"
                ></form-row-select>
              </div>
              <!--              <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 pr-0">-->
              <!--                <form-row-textarea-->
              <!--                  [icon]="'far-note'"-->
              <!--                  [label]="'note'"-->
              <!--                  [rows]="1"-->
              <!--                  [inputDisabled]="!isEditModeEnabled"-->
              <!--                  [(model)]="purchaseOrderInfo.note"-->
              <!--                ></form-row-textarea>-->
              <!--              </div>-->
            </div>
            <div class="row" *ngIf="isEditModeEnabled && isCreationModeEnabled">
              <div class="col-12">
                <div class="d-flex align-items-center mt-1">
                  <btn
                    [icon]="'far-plus'"
                    [label]="'purchase-order.fetchUnderMinimum' | translate"
                    (onEvent)="fetchProductsUnderMinimum()"
                    [classes]="['btn', 'btn-first']"
                  ></btn>
                  <p class="m-0 ml-3 info-text">
                    {{ 'purchase-order.fetchUnderMinimum.text' | translate }}
                  </p>
                </div>
              </div>
            </div>
            <div class="non-sellable-list-container" *ngIf="nonSellableProducts?.length">
              <div class="mb-3">
                <strong>{{ 'purchase-order.non-sellable-list.heading1' | translate }}</strong>
                {{ 'purchase-order.non-sellable-list.heading2' | translate }}
              </div>
              <div class="mb-3">
                <div *ngFor="let item of nonSellableProducts" class="d-flex flex-row align-items-center mb-1">
                  <div class="images-item mr-2">
                    <img class="images-item-image" [src]="getThumbUrl(item.mainImage)" [alt]="item.fullName" />
                  </div>
                  <!--                    </div>-->
                  <div>
                    <a class="link-bold text-red" target="_blank" [routerLink]="['/product', item.product]">{{
                      item.name
                    }}</a>
                  </div>
                </div>
              </div>
              <div>
                <btn
                  [label]="'purchase-order.non-sellable-list.btn' | translate"
                  (onEvent)="nonSellableProducts = []"
                  [classes]="['btn', 'btn-first']"
                ></btn>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-0">
        <div class="card" *ngIf="activeTab === 'common'">
          <p *ngIf="!loading && !productList?.length" class="text-align-center">{{ 'no.items' | translate }}</p>
          <div *ngIf="isFetchingUnderMinimum" class="text-center p-4">
            <div class="mb-2 font-weight-bold gray text-sm">
              {{ 'purchase-order.fetchUnderMinimum.loading' | translate }}
            </div>
            <div class="under-minimum-progress-bar-wrapper">
              <div class="search-progress-bar active" [class.indeterminate]="underMinimumProgress === 0">
                <div class="search-progress-bar-fill" [style.width.%]="underMinimumProgress"></div>
              </div>
            </div>
          </div>
          <p *ngIf="loading && !isFetchingUnderMinimum" class="text-align-center">
            <loading-spinner [isLoading]="true"></loading-spinner>
          </p>
          <div *ngIf="productList?.length" class="table-responsive">
            <table class="table">
              <thead>
                <tr *ngIf="isEditModeEnabled">
                  <th class="pl-0">{{ 'product.name' | translate }}</th>
                  <th class="text-nowrap text-left">{{ 'purchase.stock' | translate }}</th>
                  <th class="text-nowrap text-left">{{ 'purchase.price-without-vat' | translate }}</th>
                  <th class="text-nowrap text-left">{{ 'purchase.price-with-vat' | translate }}</th>
                  <th class="text-nowrap text-left">{{ 'numberOfItems' | translate }}</th>
                  <th class="text-nowrap text-right">{{ 'purchase.price-total-row' | translate }}</th>
                  <th class="text-nowrap text-right"></th>
                  <th *ngIf="!isCreationModeEnabled" class="text-nowrap text-left">{{ 'status' | translate }}</th>
                  <th></th>
                </tr>
                <tr *ngIf="!isEditModeEnabled">
                  <th class="pl-0">{{ 'product.name' | translate }}</th>
                  <th class="text-nowrap text-left">{{ 'purchase.stock' | translate }}</th>
                  <th class="text-nowrap text-left">{{ 'purchase.price-per-piece' | translate }}</th>
                  <th class="text-nowrap text-left">{{ 'purchase.price-per-row' | translate }}</th>
                  <th class="text-nowrap text-left">{{ 'numberOfItems' | translate }}</th>
                  <th class="text-nowrap text-left">{{ 'numberOfItems.stocked' | translate }}</th>
                  <th class="text-nowrap text-left">{{ 'status' | translate }}</th>
                  <th class="text-nowrap text-right"></th>
                  <th class="text-nowrap text-right"></th>
                  <th></th>
                </tr>
              </thead>
              <tbody *ngIf="isEditModeEnabled">
                <tr
                  *ngFor="let item of productList"
                  [ngClass]="
                    item.status?.id === 'cancelled'
                      ? 'row-cancelled'
                      : item.quantity === item.quantityIn
                        ? 'colorGrey'
                        : item.quantityIn > 0 && item.quantityIn < item.quantity
                          ? 'colorYellow'
                          : ''
                  "
                >
                  <td class="pl-1 text-left">
                    <div class="flex-gap-10 align-items-center">
                      <!--                    <div [photoGallery]="item.mainImage?.url"-->
                      <!--                         [photoGalleryCaption]="-->
                      <!--                  item.fullName + '<br>' + (item.code ?  ('product.code' | translate) + item.code : '') + '<br>' + (item.ean ? ('product.ean' | translate) + item.ean : '')"-->
                      <!--                    >-->
                      <div class="images-item">
                        <img class="images-item-image" [src]="getThumbUrl(item.mainImage)" [alt]="item.fullName" />
                      </div>
                      <!--                    </div>-->
                      <div>
                        <a class="link-bold" target="_blank" [routerLink]="['/product', item.product]">{{
                          item.name
                        }}</a>
                        <div class="product-details flex-gap-5 flex-wrap">
                          <div *ngIf="item.code && item.code.length > 0">
                            {{ 'product.code.default' | translate }}:<span> {{ item.code }}</span>
                          </div>
                        </div>
                        <!--                      <div class="product-details flex-gap-5 flex-wrap">-->
                        <!--                        <div *ngIf="item.code && item.code.length > 0">-->
                        <!--                          {{ 'product.code' | translate }}:<span> {{ item.code }}</span>-->
                        <!--                        </div>-->
                        <!--                        <div *ngIf="item.ean && item.ean.length > 0">-->
                        <!--                          {{ 'product.ean' | translate }}:<span> {{ item.ean }}</span>-->
                        <!--                        </div>-->
                        <!--                      </div>-->
                      </div>
                    </div>
                  </td>
                  <td class="font-weight-bold">
                    <span *ngIf="item.quantityHs > 30" class="text-green">{{
                      'product.quantity.moreThan100' | translate
                    }}</span>
                    <span *ngIf="item.quantityHs > 0 && item.quantityHs <= 30" class="text-yellow"
                      >{{ item.quantityHs }} ks</span
                    >
                    <span *ngIf="item.quantityHs <= 0" class="text-red">{{ 'product.quantity.zero' | translate }}</span>
                    <!--                    <span *ngIf="item.quantityAvailable > 30" class="text-green">{{-->
                    <!--                      'product.quantity.moreThan100' | translate-->
                    <!--                    }}</span>-->
                    <!--                    <span *ngIf="item.quantityAvailable > 0 && item.quantityAvailable <= 30" class="text-yellow"-->
                    <!--                      >{{ item.quantityAvailable }} ks</span-->
                    <!--                    >-->
                    <!--                    <span *ngIf="item.quantityAvailable <= 0" class="text-red">{{-->
                    <!--                      'product.quantity.zero' | translate-->
                    <!--                    }}</span>-->
                  </td>
                  <td class="text-left text-line-1">
                    <div *ngIf="item.discount <= 0">{{ item.purchasePrice | formatPrice: item.currency }}</div>
                    <div *ngIf="item.discount > 0" class="text-red font-weight-bold">
                      {{ item.purchasePrice - item.purchasePrice * (item.discount / 100) | formatPrice: item.currency }}
                    </div>
                    <div *ngIf="item.discount > 0">
                      <small class="text-strike">{{ item.purchasePrice | formatPrice: item.currency }}</small>
                    </div>
                  </td>
                  <td class="text-left text-line-1">
                    <div *ngIf="item.discount <= 0">{{ item.purchasePriceWithVat | formatPrice: item.currency }}</div>
                    <div *ngIf="item.discount > 0" class="text-red font-weight-bold">
                      {{ item.purchasePriceWithVatAndDiscount | formatPrice: item.currency }}
                      <!--                      {{-->
                      <!--                        item.purchasePriceWithVat - item.purchasePriceWithVat * (item.discount / 100)-->
                      <!--                          | formatPrice: item.currency-->
                      <!--                      }}-->
                    </div>
                    <div *ngIf="item.discount > 0">
                      <small class="text-strike">{{ item.purchasePriceWithVat | formatPrice: item.currency }}</small>
                    </div>
                  </td>
                  <!--                  <td class="text-right" [ngClass]="isCreationModeEnabled ? 'input-156' : 'input-90'">-->
                  <!--                    <form-row-input-->
                  <!--                      [model]="item.purchasePrice"-->
                  <!--                      (modelChange)="rowChange(item, 'purchasePrice', $event)"-->
                  <!--                      [showErrorBorder]="!item.isValid"-->
                  <!--                      [inputDisabled]="-->
                  <!--                        !isEditModeEnabled ||-->
                  <!--                        item.status?.id === 'stocked' ||-->
                  <!--                        item.status?.id === 'cancelled' ||-->
                  <!--                        item.status?.id === 'partly_stocked'-->
                  <!--                      "-->
                  <!--                    ></form-row-input>-->
                  <!--                  </td>-->
                  <!--                  <td class="text-right" [ngClass]="isCreationModeEnabled ? 'input-156' : 'input-90'">-->
                  <!--                    <form-row-input-->
                  <!--                      [model]="item.purchasePriceWithVat"-->
                  <!--                      (modelChange)="rowChange(item, 'purchasePriceWithVat', $event)"-->
                  <!--                      [showErrorBorder]="!item.isValid"-->
                  <!--                      [inputDisabled]="-->
                  <!--                        !isEditModeEnabled ||-->
                  <!--                        item.status?.id === 'stocked' ||-->
                  <!--                        item.status?.id === 'cancelled' ||-->
                  <!--                        item.status?.id === 'partly_stocked'-->
                  <!--                      "-->
                  <!--                    ></form-row-input>-->
                  <!--                  </td>-->
                  <td class="text-right input-70">
                    <form-row-number-with-controls
                      [model]="item.quantity"
                      [minValue]="1"
                      (modelChange)="rowChange(item, 'quantity', $event)"
                      [showErrorBorder]="!item.isValid"
                      [readonly]="
                        !isEditModeEnabled ||
                        item.status?.id === 'stocked' ||
                        item.status?.id === 'cancelled' ||
                        item.status?.id === 'partly_stocked'
                      "
                    ></form-row-number-with-controls>
                  </td>
                  <td class="text-right text-line-1">
                    <div class="d-flex align-items-center justify-content-right font-weight-bold">
                      <div>
                        <div *ngIf="item.discount <= 0">
                          {{ item.purchasePriceAllWithVat | formatPrice: item.currency }}
                        </div>
                        <div *ngIf="item.discount > 0" class="text-red">
                          {{ item.purchasePriceAllWithVatAndDiscount | formatPrice: item.currency }}
                          <!--                          {{-->
                          <!--                            (item.purchasePriceWithVat - item.purchasePriceWithVat * (item.discount / 100)) * item.quantity-->
                          <!--                              | formatPrice: item.currency-->
                          <!--                          }}-->
                          <!--                          // this gets rounding error:-->
                          <!--                          {{-->
                          <!--                            item.purchasePriceAllWithVat - item.purchasePriceAllWithVat * (item.discount / 100)-->
                          <!--                              | formatPrice: item.currency-->
                          <!--                          }}-->
                        </div>
                        <div *ngIf="item.discount <= 0">
                          <small
                            >{{ item.purchasePriceAll | formatPrice: item.currency }}
                            {{ 'without-vat' | translate }}</small
                          >
                        </div>
                        <div *ngIf="item.discount > 0">
                          <small>
                            {{ item.purchasePriceAllWithDiscount | formatPrice: item.currency }}
                            {{ 'without-vat' | translate }}
                          </small>
                        </div>
                      </div>
                      <!--                      <div *ngIf="item.discount > 0" class="discount-badge">-{{item.discount}}%</div>-->
                    </div>
                  </td>
                  <td>
                    <div *ngIf="item.discount > 0" class="discount-badge">-{{ item.discount.toFixed(2) }}%</div>
                  </td>
                  <td *ngIf="!isCreationModeEnabled" class="text-left">
                    {{ 'purchaseOrderStatus.' + item.status.id | translate }}
                  </td>
                  <td class="text-right text-nowrap">
                    <btn
                      *ngIf="
                        item.status?.id !== 'stocked' &&
                        item.status?.id !== 'partly_stocked' &&
                        item.status?.id !== 'cancelled' &&
                        purchaseOrder?.status?.id !== 'draft' &&
                        isEditModeEnabled &&
                        !isCreationModeEnabled
                      "
                      [label]="'cancel' | translate"
                      [title]="'cancel' | translate"
                      [icon]="'fa-ban'"
                      [classes]="['btn-sm', 'btn-second', 'mr-2']"
                      (click)="stockUpCancel(item)"
                    ></btn>
                    <btn
                      *ngIf="
                        item.status?.id === 'partly_stocked' &&
                        purchaseOrder.status?.id !== 'draft' &&
                        isEditModeEnabled &&
                        !isCreationModeEnabled
                      "
                      [label]="'cancel.rest' | translate"
                      [title]="'cancel.rest' | translate"
                      [icon]="'fa-ban'"
                      [classes]="['btn-sm', 'btn-second', 'mr-2']"
                      (click)="stockUpCancelRest(item)"
                    ></btn>
                    <btn
                      *ngIf="isEditModeEnabled || isCreationModeEnabled"
                      [title]="'delete' | translate"
                      [icon]="'far-trash-alt'"
                      [classes]="['btn-sm', 'btn-trash']"
                      (click)="remove(item)"
                    ></btn>
                  </td>
                </tr>
              </tbody>
              <tbody *ngIf="!isEditModeEnabled">
                <tr
                  *ngFor="let item of productList"
                  [ngClass]="
                    item.status?.id === 'cancelled'
                      ? 'row-cancelled'
                      : item.quantity === item.quantityIn
                        ? 'colorGrey'
                        : item.quantityIn > 0 && item.quantityIn < item.quantity
                          ? 'colorYellow'
                          : ''
                  "
                >
                  <td class="pl-1 text-left">
                    <div class="flex-gap-10 align-items-center">
                      <!--                    <div [photoGallery]="item.mainImage?.url"-->
                      <!--                         [photoGalleryCaption]="-->
                      <!--                  item.fullName + '<br>' + (item.code ?  ('product.code' | translate) + item.code : '') + '<br>' + (item.ean ? ('product.ean' | translate) + item.ean : '')"-->
                      <!--                    >-->
                      <div class="images-item">
                        <img class="images-item-image" [src]="getThumbUrl(item.mainImage)" [alt]="item.fullName" />
                      </div>
                      <!--                    </div>-->
                      <div>
                        <a class="link-bold" target="_blank" [routerLink]="['/product', item.product]">{{
                          item.name
                        }}</a>
                        <div class="product-details flex-gap-5 flex-wrap">
                          <div *ngIf="item.code && item.code.length > 0">
                            {{ 'product.code.default' | translate }}:<span> {{ item.code }}</span>
                          </div>
                        </div>
                        <!--                        <div *ngIf="item.ean && item.ean.length > 0">-->
                        <!--                          {{ 'product.ean' | translate }}:<span> {{ item.ean }}</span>-->
                        <!--                        </div>-->
                        <!--                      </div>-->
                      </div>
                    </div>
                  </td>
                  <td>
                    <span *ngIf="item.quantityHs > 30" class="text-green">{{
                      'product.quantity.moreThan100' | translate
                    }}</span>
                    <span *ngIf="item.quantityHs > 0 && item.quantityHs <= 30" class="text-yellow"
                      >{{ item.quantityHs }} ks</span
                    >
                    <span *ngIf="item.quantityHs <= 0" class="text-red">{{ 'product.quantity.zero' | translate }}</span>
                    <!--                    <span *ngIf="item.quantityAvailable > 30" class="text-green">{{-->
                    <!--                      'product.quantity.moreThan100' | translate-->
                    <!--                    }}</span>-->
                    <!--                    <span *ngIf="item.quantityAvailable > 0 && item.quantityAvailable <= 30" class="text-yellow"-->
                    <!--                      >{{ item.quantityAvailable }} ks</span-->
                    <!--                    >-->
                    <!--                    <span *ngIf="item.quantityAvailable <= 0" class="text-red">{{-->
                    <!--                      'product.quantity.zero' | translate-->
                    <!--                    }}</span>-->
                  </td>
                  <td class="text-left text-line-1">
                    <div *ngIf="item.discount <= 0">
                      <div>{{ item.purchasePriceWithVat | formatPrice: item.currency }}</div>
                      <div>
                        <small
                          >{{ item.purchasePrice | formatPrice: item.currency }} {{ 'without-vat' | translate }}</small
                        >
                      </div>
                    </div>
                    <div *ngIf="item.discount > 0" class="text-red">
                      {{ item.purchasePriceWithVatAndDiscount | formatPrice: item.currency }}
                    </div>
                    <div *ngIf="item.discount > 0">
                      <small class="text-strike">{{ item.purchasePriceWithVat | formatPrice: item.currency }}</small>
                    </div>
                  </td>
                  <td class="text-left text-line-1">
                    <div *ngIf="item.discount <= 0">
                      <div>{{ item.purchasePriceWithVat * item.quantity | formatPrice: item.currency }}</div>
                      <div>
                        <small
                          >{{ item.purchasePrice * item.quantity | formatPrice: item.currency }}
                          {{ 'without-vat' | translate }}</small
                        >
                      </div>
                    </div>
                    <div *ngIf="item.discount > 0" class="text-red">
                      {{ item.purchasePriceAllWithVatAndDiscount | formatPrice: item.currency }}
                    </div>
                    <div *ngIf="item.discount > 0">
                      <small class="text-strike">{{
                        item.purchasePriceWithVat * item.quantity | formatPrice: item.currency
                      }}</small>
                    </div>
                  </td>
                  <td class="text-left">
                    <div>{{ item.quantity }}</div>
                  </td>
                  <td class="text-left">
                    <div>{{ item.quantityIn }}</div>
                  </td>
                  <td class="text-left">
                    {{ 'purchaseOrderStatus.' + item.status.id | translate }}
                  </td>
                  <td>
                    <!--                    todo created order??-->
                    <div *ngIf="item.discount > 0" class="discount-badge">-{{ item.discount.toFixed(2) }}%</div>
                  </td>
                  <td class="text-right text-nowrap">
                    <btn
                      *ngIf="
                        item.status?.id !== 'stocked' && item.status?.id !== 'cancelled' && item.status?.id !== 'draft'
                      "
                      [label]="'stock.up' | translate"
                      [title]="'stock.up' | translate"
                      [icon]="'far-layer-plus'"
                      [classes]="['btn-sm', 'btn-second']"
                      (click)="stockUp(item)"
                    ></btn>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="d-flex flex-row justify-content-between row align-items-center">
            <div class="col-8 pl-3">
              <div class="row mb-5">
                <div
                  class="col-8"
                  *ngIf="
                    freeShippingThreshold - priceWithVatSum > 0 &&
                    (purchaseOrder?.id <= 0 || (purchaseOrder?.status?.id === 'draft' && isEditModeEnabled))
                  "
                >
                  <div class="pb-1">
                    {{ 'purchaseOrder.freeShipping.remaining1' | translate }}
                    <span class="text-red text-bold">{{
                      freeShippingThreshold - priceWithVatSum | formatPrice: purchaseCurrencyFromCompany
                    }}</span>
                    {{ 'purchaseOrder.freeShipping.remaining2' | translate }}
                    <span class="text-red text-bold">{{ 'purchaseOrder.freeShipping.remaining3' | translate }}</span>
                  </div>
                  <p-progressBar
                    class="progress-bar-free-shipping"
                    [color]="'#ED1C24'"
                    [showValue]="false"
                    [value]="(priceWithVatSum / freeShippingThreshold) * 100"
                  ></p-progressBar>
                </div>
                <div
                  class="col-8"
                  *ngIf="
                    freeShippingThreshold - priceWithVatSum <= 0 &&
                    (purchaseOrder?.id <= 0 || (purchaseOrder?.status?.id === 'draft' && isEditModeEnabled))
                  "
                >
                  <div class="pb-1">
                    {{ 'purchaseOrder.freeShipping.free1' | translate }}
                    <span class="color-teal">{{ 'purchaseOrder.freeShipping.free2' | translate }}</span>
                  </div>
                  <p-progressBar [color]="'#40BFBF'" [showValue]="false" [value]="100"></p-progressBar>
                </div>
                <!--                <div>{{((priceWithVatSum / freeShippingThreshold) * 100) <= 100 ? ((priceWithVatSum / freeShippingThreshold) * 100) : 100}}</div>-->
                <!--                <div *ngIf="freeShippingThreshold - priceWithVatSum > 0">{{'purchaseOrder.freeShipping.remaining1' | translate}} <span class="text-red">{{(freeShippingThreshold - priceWithVatSum) | formatPrice : purchaseCurrencyFromCompany}}</span> {{'purchaseOrder.freeShipping.remaining2' | translate}} <span class="text-red">{{'purchaseOrder.freeShipping.remaining3' | translate}}</span></div>-->
                <!--                <div *ngIf="freeShippingThreshold - priceWithVatSum <= 0">{{'purchaseOrder.freeShipping.free1' | translate}} <span class="text-blue">{{'purchaseOrder.freeShipping.free2' | translate}}</span></div>-->
              </div>
              <modal-product-search-purchase-hs
                *ngIf="isEditModeEnabled"
                (chosenProduct)="addProduct($event)"
              ></modal-product-search-purchase-hs>
            </div>
            <div class="col-4 d-flex flex-row justify-content-end">
              <div class="price-box">
                <table>
                  <tr>
                    <td>{{ 'price.sum.without.vat' | translate }}</td>
                    <td class="text-right">{{ priceSum | formatPrice: purchaseCurrencyFromCompany }}</td>
                  </tr>
                  <tr>
                    <td>{{ 'price.vat' | translate }}</td>
                    <td class="text-right">
                      {{ priceWithVatSum - priceSum | formatPrice: purchaseCurrencyFromCompany }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ 'purchaseOrder.shipping' | translate }}</td>
                    <td class="text-right text-primary text-bold">
                      {{
                        shippingPrice === 0
                          ? ('purchaseOrder.freeShipping.free3' | translate)
                          : (shippingPrice | formatPrice: purchaseCurrencyFromCompany)
                      }}
                    </td>
                  </tr>
                  <tr class="text-bold text-bigger">
                    <td>{{ 'price.sum.with.vat' | translate }}</td>
                    <td class="text-right">
                      {{ priceWithVatSum + shippingPrice | formatPrice: purchaseCurrencyFromCompany }}
                    </td>
                  </tr>
                  <tr *ngIf="discountsSum > 0">
                    <td colspan="2">
                      <div class="discount-badge-sum text-center">
                        {{ 'price.sum.discounts.with.vat' | translate }}:
                        {{ discountsSum | formatPrice: purchaseCurrencyFromCompany }}
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <!--          <div class="info-text-price d-flex align-items-center mr-0">-->
          <!--            <p class="m-0">-->
          <!--              {{ 'price.info-text-1' | translate }}-->
          <!--              <br />-->
          <!--              {{ 'price.info-text-2' | translate }}-->
          <!--            </p>-->
          <!--            <i class="fal fa-info-circle"></i>-->
          <!--          </div>-->
        </div>
        <div *ngIf="!isCreationModeEnabled && activeTab === 'dls'" class="">
          <div class="card">
            <div class="d-flex flex-row align-items-center dl-list-tr">
              <span class="dl-list-th">Dodací listy</span>
              <!--              <i class="far fa-caret-up ml-2" style="color: #7e84a3"></i>-->
            </div>
            <div *ngFor="let poDoc of purchaseOrderDocuments" class="d-flex flex-row align-items-center dl-list-tr">
              <div>
                <i class="far fa-file-pdf mr-3 text-primary"></i>
              </div>
              <div>
                <span
                  class="link-bold cursor-pointer"
                  (click)="showDocument(poDoc?.url)"
                  (keydown)="showDocument(poDoc?.url)"
                  tabindex="-1"
                >
                  {{ poDoc?.name }}
                </span>
              </div>
            </div>
            <div *ngIf="!purchaseOrderDocuments?.length" class="d-flex flex-row align-items-center dl-list-tr">
              <span class="dl-list-empty">{{ 'purchase-orders.tab.dls.empty' | translate }}</span>
            </div>
          </div>
        </div>
        <div *ngIf="!isCreationModeEnabled && activeTab === 'pmps'" class="">
          <app-base-listing
            [storageKey]="storageKey"
            [loadingNextItems]="loading"
            [loadingItems]="reloading"
            [items]="productMovePacks"
            [columns]="listingColumns"
            [totalItems]="totalItems"
            [currentPage]="currentPage"
            [endPage]="endPage"
            [(sortProp)]="sortProp"
            [(sortDir)]="sortDir"
            (reloadList)="filter()"
            (switchPage)="filter($event.currentPage, $event.sortProp, $event.sortDir, $event.concat)"
            (callAction)="callAction($event)"
          ></app-base-listing>
        </div>
      </div>
    </div>
  </section>
  <modal-qrcode #modalQr></modal-qrcode>
</div>
